import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';  // Thêm import CommonModule
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'; // Thêm import NgbDropdownModule
import { LanguageService, Language } from '@core/services/language.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-language-dropdown',
  templateUrl: './language-dropdown.component.html',
  standalone: true, // Nếu bạn đang sử dụng standalone component
  imports: [
    CommonModule, // Import CommonModule cho ngFor, ngIf
    NgbDropdownModule // Import NgbDropdownModule cho ngbDropdown
  ]
})
export class LanguageDropdownComponent implements OnInit, OnDestroy {
  languages: Language[] = [];
  selectedLang: Language;
  isLoading = false;
  
  private subscriptions: Subscription = new Subscription();

  constructor(private languageService: LanguageService,private router: Router) {
    this.languages = this.languageService.getLanguages();
    this.selectedLang = this.languageService.getCurrentLanguage();
  }

  ngOnInit(): void {
    // Subscribe to language changes
    this.subscriptions.add(
      this.languageService.currentLanguage$.subscribe(lang => {
        this.selectedLang = lang;
      })
    );
    
    // Subscribe to loading status
    this.subscriptions.add(
      this.languageService.isLoading$.subscribe(loading => {
        this.isLoading = loading;
      })
    );
  }

  changeLanguage(langCode: string): void {
    if (this.selectedLang.code !== langCode && !this.isLoading) {
      this.languageService.changeLanguage(langCode);
      const currentUrl = this.router.url;
      if (currentUrl.startsWith('/auth')) return;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigateByUrl(currentUrl);
      });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
